// extracted by mini-css-extract-plugin
export var bookingCta = "Nav-module--booking-cta--9c336";
export var bookingLink = "Nav-module--booking-link--27aea";
export var careersContainer = "Nav-module--careersContainer--4720a";
export var careersLink = "Nav-module--careersLink--5c3d3";
export var careersLogo = "Nav-module--careersLogo--25e24";
export var careersText = "Nav-module--careersText--05cc0";
export var cta = "Nav-module--cta--7a1b9";
export var desktop = "Nav-module--desktop--15552";
export var desktopText = "Nav-module--desktop-text--8c823";
export var hoverEffect = "Nav-module--hoverEffect--2f550";
export var loginButton = "Nav-module--login-button--90ec3";
export var mobile = "Nav-module--mobile--13c33";
export var mobileText = "Nav-module--mobile-text--a1932";
export var nav = "Nav-module--nav--a2305";
export var portalButtons = "Nav-module--portal-buttons--90e91";
export var root = "Nav-module--root--7e616";
export var spacer = "Nav-module--spacer--2b02b";
export var transitioning = "Nav-module--transitioning--8c6c5";